//@ts-check

// @ts-ignore
import * as Turbo from "@hotwired/turbo"
import Alpine from "alpinejs"
import "index.css"
import tippy from "tippy.js"
import "tippy.js/dist/tippy.css"
import { updateTheme } from "./updateTheme"
import { updateThemeWithoutTransitions } from "./updateThemeWithoutTransitions"
import "focus-visible"

const WebShareWrapper = require("web-share-wrapper")
export let mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")

// These need to come before starting alpine!

document.addEventListener("alpine:init", () => {
  Alpine.directive("tooltip", (el, { expression }) => {
    tippy(el, { content: expression })
  })

  Alpine.magic("clipboard", () => subject => {
    try {
      navigator.clipboard.writeText(subject)
    } catch (error) {
      console.log("clipboard:", error)
    }
  })

  Alpine.magic("toggleTheme", () => {
    let savedTheme = document.documentElement.getAttribute("data-theme")
    console.log("Current theme:", savedTheme)
    if (savedTheme === "dark") {
      document.documentElement.setAttribute("data-theme", updateTheme("light"))
    } else if (savedTheme === "light") {
      document.documentElement.setAttribute("data-theme", updateTheme("dark"))
    } else {
      document.documentElement.setAttribute("data-theme", updateTheme("dark"))
    }
  })
})

// @ts-ignore
window.Alpine = Alpine
Alpine.start()

// Debugging
document.addEventListener("turbo:load", () => {
  console.log("turbo:load")
})

document.addEventListener("turbo:visit", () => {
  console.log("turbo:visit")
})

document.documentElement.setAttribute("data-theme", updateTheme())

new MutationObserver(([{ oldValue }]) => {
  let newValue = document.documentElement.getAttribute("data-theme")
  if (newValue !== oldValue) {
    try {
      window.localStorage.setItem("theme", newValue)
    } catch {}
    updateThemeWithoutTransitions(newValue)
  }
}).observe(document.documentElement, { attributeFilter: ["data-theme"], attributeOldValue: true })

mediaQuery.addEventListener("change", updateThemeWithoutTransitions)
window.addEventListener("storage", updateThemeWithoutTransitions)
